import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { PrivateRoute, withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import TabLink from '../Utils/TabLink'
import ProfileApp from '../Dashboard/ProfileApp'
import CustodianProfile from '../Dashboard/CustodianProfile'
import ListBookings from './Bookings/ListBookings'
import Calendar from '../Dashboard/Calendar/Calendar'
import EditPlace from './EditPlace'
import RecipientProfile from './RecipientProfile'
import RequestsTabs from './Bookings/RequestsTabs'
import ProfileLogo from '../../../images/icons/dashboard/profile.svg'
import BookingsLogo from '../../../images/icons/dashboard/bookings.svg'
import PlacesLogo from '../../../images/icons/dashboard/place.svg'
import RequestsLogo from '../../../images/icons/dashboard/requests.svg'
import CalendarLogo from '../../../images/icons/dashboard/calendar-sm.svg'

const Col12 = styled.div`
  padding: 0px !important;
`

class Dashboard extends Component {
  constructor(props) {
    super(props)

    this.handleDashboardNav = this.handleDashboardNav.bind(this)
  }

  handleDashboardNav(i) {
    const links = this.state.dashboardLinks.slice()
    for (const j in links) {
      links[j].isActive = i == j
    }
    this.setState({ dashboardLinks: links })
  }

  render() {
    const u = this.props.auth.user
    if (u === null) {
      console.log('user is null!')
      //this.props.history.push("/loginsignup");
    }

    const isCustodian = u.user_type == 'custodian'
    const isRecipient = u.user_type == 'recipient'

    console.log('u.status: ' + u.status)
    console.log('u.user_type: ' + u.user_type)
    let dashboardLinks = []

    if (!isCustodian && u.status == 'approvedfinal') {
      dashboardLinks = [
        {
          path: '/dashboard',
          text: 'Profile',
          isActive: false,
          hasTabs: false,
          icon: ProfileLogo,
        },
        {
          path: '/dashboard/edit-place',
          text: 'Add / Edit Place',
          isActive: false,
          hasTabs: false,
          icon: PlacesLogo,
        },
        {
          path: '/dashboard/bookings',
          text: 'Bookings',
          isActive: false,
          hasTabs: false,
          icon: BookingsLogo,
        },
        {
          path: '/dashboard/requests',
          text: 'Requests',
          isActive: false,
          hasTabs: true,
          icon: RequestsLogo,
        },
        {
          path: '/dashboard/calendar',
          text: 'Calendar',
          isActive: false,
          hasTabs: true,
          icon: CalendarLogo,
        },
      ]
    } else if (
      (!isCustodian && u.status == 'approved') ||
      u.status == 'completed'
    ) {
      dashboardLinks = [
        {
          path: '/dashboard',
          text: 'Profile',
          isActive: true,
          hasTabs: false,
          icon: ProfileLogo,
        },
        {
          path: '/dashboard/requests',
          text: 'Requests',
          isActive: false,
          hasTabs: true,
          icon: RequestsLogo,
        },
        {
          path: '/dashboard/calendar',
          text: 'Calendar',
          isActive: false,
          hasTabs: true,
          icon: CalendarLogo,
        },
      ]
    } else {
      dashboardLinks = [
        {
          path: '/dashboard',
          text: 'Profile',
          isActive: true,
          hasTabs: false,
          icon: ProfileLogo,
        },
      ]
    }

    for (let i = 0; i < dashboardLinks.length; i++) {
      console.log('dashboardLinks[i].path: ' + dashboardLinks[i].path)
      console.log(
        'this.props.location.pathname: ' + this.props.location.pathname
      )

      console.log('dashboardLinks[i].path: ' + dashboardLinks[i].path)
      console.log(
        'this.props.location.pathname: ' + this.props.location.pathname
      )

      if (dashboardLinks[i].hasTabs) {
        dashboardLinks[i].isActive = this.props.location.pathname.startsWith(
          dashboardLinks[i].path
        )
          ? true
          : false
      } else {
        dashboardLinks[i].isActive =
          dashboardLinks[i].path === this.props.location.pathname ? true : false
      }
    }

    return (
      <section className="contact-wrapper dashboard">
        <div className="container">
          <div className="row justify-content-center">
            <Col12 className="col-md-12">
              <div className="contact_form">
                <ul className="nav nav-tabs justify-content-center">
                  {dashboardLinks.map((link, i) => (
                    <TabLink
                      path={link.path}
                      text={link.text}
                      isActive={link.isActive}
                      key={link.path}
                      icon={link.icon}
                    />
                  ))}
                </ul>
                {isCustodian ? (
                  <PrivateRoute
                    exact
                    path={'/dashboard'}
                    component={withAuth(CustodianProfile)}
                  />
                ) : isRecipient ? (
                  <Fragment>
                    <PrivateRoute
                      exact
                      path={'/dashboard'}
                      component={withAuth(RecipientProfile)}
                    />
                    <PrivateRoute
                      exaxt
                      path={'/dashboard/edit-place'}
                      component={withAuth(EditPlace)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/bookings'}
                      component={withAuth(ListBookings)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/requests/live'}
                      component={withAuth(RequestsTabs)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/requests/past'}
                      component={withAuth(RequestsTabs)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/requests/pending'}
                      component={withAuth(RequestsTabs)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/calendar'}
                      component={withAuth(Calendar)}
                    />
                  </Fragment>
                ) : (
                  <Fragment>
                    <PrivateRoute
                      exact
                      path={'/dashboard'}
                      component={withAuth(ProfileApp)}
                    />
                    <PrivateRoute
                      exaxt
                      path={'/dashboard/edit-place'}
                      component={withAuth(EditPlace)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/bookings'}
                      component={withAuth(ListBookings)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/requests/live'}
                      component={withAuth(RequestsTabs)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/requests/past'}
                      component={withAuth(RequestsTabs)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/requests/pending'}
                      component={withAuth(RequestsTabs)}
                    />
                    <PrivateRoute
                      exact
                      path={'/dashboard/calendar'}
                      component={withAuth(Calendar)}
                    />
                  </Fragment>
                )}
              </div>
            </Col12>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withAuth(withSearch(Dashboard)))
